<div class="modal fade {{modalClass}}" id="{{modalId}}" tabindex="-1" {{#if modalTitle}} aria-labelledby="{{modalId}}Label" {{/if}} aria-hidden="true">
	<div class="modal-dialog">
		<div class="modal-content {{modalContentClass}}">
			<div class="modal-header {{#unless modalTitle}}border-bottom-0{{/unless}}">
				{{#if modalTitle}}
				<h5 class="modal-title" id="{{modalId}}Label">{{modalTitle}}</h5>
				{{/if}}
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				{{{modalContent}}}
			</div>
			{{#if displayButtons}}
			<div class="modal-footer">
				{{#if cancelButton}}
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{cancelButton}}</button>
				{{/if}}
				{{#if confirmButton}}
				<button type="button" class="btn btn-primary">{{confirmButton}}</button>
				{{/if}}
			</div>
			{{/if}}
		</div>
	</div>
</div>